import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

export default createSvgIcon(
  [<path fill="url(#a)" d="M.3389.0693h136.05v41.8614H.3389z" key="0" />,<defs key="1"><pattern id="a" width="1" height="1" patternContentUnits="objectBoundingBox"><use xlinkHref="#b" transform="matrix(.00172 0 0 .00569 -.0617 -.2111)" /></pattern></defs>,]
, 'GeneralGooglePlayStoreBadgex');
